export enum ContentType {
  RICH_TEXT = 'RICH_TEXT',
  VIDEO = 'VIDEO',
  YOUTUBE = 'YOUTUBE',
  VIMEO = 'VIMEO',
  HTML = 'HTML',
  PDF = 'PDF',
  ACTIVITY = 'ACTIVITY'
}